import { ManualOption } from "../../types";

import * as yup from "yup";
import { SelfServeOption } from "../../types";

const emailSchema = yup
  .string()
  .email("Invalid email format")
  .matches(
    /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.((?!con$)[a-zA-Z0-9]{2,12})$/,
    "Invalid email format"
  )
  .required("Email is required");

const nameSchema = yup
  .string()
  .min(2, "Name must be at least 2 characters")
  .required("Name is required");

export const validateForms = (
  option: SelfServeOption | ManualOption,
  options: (SelfServeOption | ManualOption)[]
): string | undefined => {
  if (option.type === "self-serve") {
    try {
      emailSchema.validateSync(option.email);
    } catch (error) {
      if (error instanceof yup.ValidationError) return error.message;
    }

    if (
      options.some(
        (existingOption) =>
          existingOption.type === "self-serve" &&
          existingOption.email === option.email
      )
    )
      return "Email already added";
  }

  if (option.type === "manual") {
    try {
      nameSchema.validateSync(option.first_name);
      nameSchema.validateSync(option.last_name);
    } catch (error) {
      if (error instanceof yup.ValidationError) return error.message;
    }

    if (
      options.some(
        (existingOption) =>
          existingOption.type === "manual" &&
          existingOption.first_name === option.first_name &&
          existingOption.last_name === option.last_name
      )
    )
      return "Person already added";
  }
};
